import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import CartDrawer from "@/components/CartDrawer";
import FloatingCart from "@/components/FloatingCart";
import Lightbox from "@/components/Lightbox";
import KostBranchSection from "@/components/KostBranchSection";
import { api, trackWaClick } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { motion } from "framer-motion";
import { Home, Wind, Snowflake, Bath, BedDouble, Wifi, ArrowLeft, Loader2, CalendarCheck, MessageCircle, Bike, UtensilsCrossed, ShowerHead, Shirt } from "lucide-react";

const BRANCHES = [
  {
    id: "kost-01",
    name: "FAS KOST 01",
    address: "Komplek Bumi Ayu Lestari Blok A No. 12",
    mapsQuery: "-0.15806421914117832,109.41624225530447",
    facilities: [
      "Parkir motor luas & beratap",
      "Pantry bersama (kulkas, dispenser, kompor)",
      "Area jemur beratap",
      "Toilet & kamar mandi bersama yang bersih",
    ],
    photos: [
      { url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_fasmart-online/artifacts/s5382tba_ChatGPT%20Image%2026%20Agu%202026%2C%2009.23.29%20%285%29.png", caption: "Tampak Depan & Parkir Motor", icon: Bike, big: true },
      { url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_fasmart-online/artifacts/dhgzd9hp_ChatGPT%20Image%2026%20Agu%202026%2C%2009.23.27%20%282%29.png", caption: "Budget Room — Lantai 1 (Rp 650rb/bln)", icon: BedDouble },
      { url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_fasmart-online/artifacts/6hfqhgg2_ChatGPT%20Image%2026%20Agu%202026%2C%2009.23.29%20%286%29.png", caption: "Toilet & Kamar Mandi Bersama", icon: ShowerHead },
      { url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_fasmart-online/artifacts/4tnl7cev_ChatGPT%20Image%2026%20Agu%202026%2C%2009.23.30%20%287%29.png", caption: "Area Jemur", icon: Shirt },
      { url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_fasmart-online/artifacts/aknllpuy_ChatGPT%20Image%2026%20Agu%202026%2C%2009.23.28%20%284%29.png", caption: "Pantry FAS KOST", icon: UtensilsCrossed },
    ],
  },
  {
    id: "kost-02",
    name: "FAS KOST 02",
    address: "Komplek Bumi Ayu Lestari Blok B No. 9",
    mapsQuery: "-0.15851735717793583,109.41664075938621",
    facilities: [
      "10 kamar — AC + KM Dalam (Lt.2), Kost Biasa (Lt.1)",
      "WiFi",
      "Parkir motor luas",
      "Area jemur beratap + wastafel cuci",
    ],
    photos: [
      { url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_fasmart-online/artifacts/73s8eg70_ChatGPT%20Image%2026%20Agu%202026%2C%2011.37.17.png", caption: "Tampak Depan & Parkir Motor", icon: Home, big: true },
      { url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_fasmart-online/artifacts/dn2tkd26_ChatGPT%20Image%2026%20Agu%202026%2C%2011.37.23%20%281%29.png", caption: "Kamar AC + KM Dalam (Lt.2)", icon: Snowflake },
      { url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_fasmart-online/artifacts/7a5qkvtt_ChatGPT%20Image%2026%20Agu%202026%2C%2011.37.24%20%282%29.png", caption: "Kamar Kipas No. 101 (Lt.1)", icon: Wind },
      { url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_fasmart-online/artifacts/0lfv3i3u_ChatGPT%20Image%2026%20Agu%202026%2C%2011.37.24%20%283%29.png", caption: "Area Jemur Beratap", icon: Shirt },
    ],
  },
];
import { toast } from "sonner";

const ROOMS = [
  {
    id: "kipas",
    name: "Kamar Kipas + Toilet Luar",
    price: "Rp 650.000",
    per: "/bulan",
    images: [
      "https://images.unsplash.com/photo-1586310520462-658e93388399?auto=format&fit=crop&w=700&q=80",
      "https://images.pexels.com/photos/8864908/pexels-photo-8864908.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ],
    facilities: [
      { icon: Wind, label: "Kipas angin" },
      { icon: Bath, label: "Toilet luar (sharing)" },
      { icon: BedDouble, label: "Kasur + lemari" },
    ],
  },
  {
    id: "ac",
    name: "Kamar AC + Toilet Dalam",
    price: "Rp 1.000.000",
    per: "/bulan",
    images: [
      "https://images.unsplash.com/photo-1744974256549-8ece7cdb5dd2?auto=format&fit=crop&w=700&q=80",
      "https://images.unsplash.com/photo-1692455067486-d4637182a61c?auto=format&fit=crop&w=700&q=80",
    ],
    facilities: [
      { icon: Snowflake, label: "AC" },
      { icon: Bath, label: "Toilet dalam" },
      { icon: BedDouble, label: "Kasur + lemari" },
      { icon: Wifi, label: "Akses FASNET WiFi" },
    ],
  },
];

export default function Kost() {
  const [form, setForm] = useState({ name: "", phone: "", branch: "kost-01", room_type: "kipas", visit_date: "", notes: "" });
  const [loading, setLoading] = useState(false);
  const [lightbox, setLightbox] = useState({ images: [], index: null });

  const submit = async () => {
    if (!form.name.trim() || !form.phone.trim()) {
      return toast.error("Lengkapi nama dan nomor HP");
    }
    setLoading(true);
    try {
      await api.post("/kost/booking", form);
      toast.success("Booking kunjungan terkirim!", { description: "Pengelola FAS KOST akan menghubungi kamu untuk jadwal survey kamar." });
      setForm({ name: "", phone: "", branch: "kost-01", room_type: "kipas", visit_date: "", notes: "" });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Gagal mengirim booking");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen paper-bg">
      <Navbar />
      <CartDrawer />
      <FloatingCart />

      {/* Hero */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 pt-8 pb-4">
        <Link to="/" data-testid="back-to-home-btn" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-emerald-700 text-white text-sm font-bold shadow-md shadow-emerald-700/25 hover:bg-emerald-800 hover:shadow-lg hover:-translate-y-0.5 transition">
          <ArrowLeft className="w-4 h-4" /> Kembali Belanja
        </Link>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mt-4 relative overflow-hidden rounded-3xl bg-gradient-to-br from-amber-700 via-amber-800 to-stone-900 text-white p-8 md:p-12"
        >
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "radial-gradient(circle at 20% 25%, rgba(251,191,36,0.4), transparent 40%), radial-gradient(circle at 85% 80%, rgba(217,119,6,0.35), transparent 45%)" }} />
          <div className="relative max-w-2xl">
            <span className="tag-pill bg-amber-400 text-stone-900">
              <Home className="w-3 h-3" /> FAS KOST
            </span>
            <h1 className="mt-5 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Hunian nyaman, <span className="text-amber-300">harga tetangga.</span>
            </h1>
            <p className="mt-5 text-amber-50/90 text-sm md:text-base leading-relaxed max-w-lg">
              Kost mulai Rp 650rb/bulan. Lihat kamar dulu lewat booking kunjungan gratis — booking & bayar sewa gampang lewat warung FASMART.
            </p>
            <a
              href="#booking-kost"
              data-testid="kost-booking-cta"
              className="mt-7 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-amber-400 text-stone-900 font-bold hover:bg-amber-300 transition shadow-lg shadow-amber-400/30"
            >
              <CalendarCheck className="w-4 h-4" /> Booking Kunjungan Gratis
            </a>
          </div>
        </motion.div>
      </section>

      {/* Room gallery */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-8">
        <h2 className="font-display font-black text-3xl md:text-4xl tracking-tight text-stone-900">Tipe Kamar</h2>
        <p className="text-stone-600 mt-1">Dua pilihan sesuai budget — semua sudah termasuk kasur & lemari.</p>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          {ROOMS.map((r, i) => (
            <motion.div
              key={r.id}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className="rounded-3xl bg-white border border-[#E5DECF] overflow-hidden card-tilt"
              data-testid={`kost-room-${r.id}`}
            >
              <div className="grid grid-cols-2 gap-1 p-1">
                {r.images.map((img, j) => (
                  <button
                    key={j}
                    type="button"
                    data-testid={`kost-room-${r.id}-photo-${j}`}
                    onClick={() => setLightbox({ images: r.images.map((url) => ({ url, caption: r.name })), index: j })}
                    className="group overflow-hidden rounded-2xl cursor-zoom-in focus:outline-none focus:ring-2 focus:ring-amber-500"
                  >
                    <img src={img} alt={`${r.name} foto ${j + 1}`} className="w-full h-44 sm:h-56 object-cover group-hover:scale-105 transition-transform duration-500" />
                  </button>
                ))}
              </div>
              <div className="p-6">
                <h3 className="font-display font-bold text-xl leading-tight">{r.name}</h3>
                <div className="mt-2 flex items-baseline gap-1">
                  <span className="font-display font-black text-3xl text-amber-700">{r.price}</span>
                  <span className="text-sm text-stone-500">{r.per}</span>
                </div>
                <div className="mt-4 flex flex-wrap gap-2">
                  {r.facilities.map((f) => (
                    <span key={f.label} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-amber-50 border border-amber-200 text-xs font-semibold text-amber-900">
                      <f.icon className="w-3.5 h-3.5" /> {f.label}
                    </span>
                  ))}
                </div>
                <a
                  href="#booking-kost"
                  onClick={() => setForm((f) => ({ ...f, room_type: r.id }))}
                  data-testid={`kost-room-book-btn-${r.id}`}
                  className="mt-5 inline-block w-full text-center px-5 py-3 rounded-full bg-amber-700 text-white font-bold hover:bg-amber-800 transition"
                >
                  Booking Kunjungan Kamar Ini
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Preview cabang FAS KOST — tambah cabang cukup tambah objek di BRANCHES */}
      {BRANCHES.map((b) => (
        <KostBranchSection
          key={b.id}
          branch={b}
          onPhotoClick={(i) => setLightbox({ images: b.photos, index: i })}
        />
      ))}

      {/* Form booking kunjungan */}
      <section id="booking-kost" className="max-w-7xl mx-auto px-4 md:px-8 py-8">
        <div className="rounded-3xl bg-gradient-to-br from-amber-700 to-stone-900 text-white p-8 md:p-10">
          <h2 className="font-display font-black text-3xl md:text-4xl tracking-tight">Form Booking Kunjungan</h2>
          <p className="text-amber-100/90 mt-2 max-w-xl">Gratis & tanpa komitmen — lihat kamar langsung, tanya-tanya pengelola, baru putuskan.</p>
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl">
            <div>
              <Label className="text-amber-100">Nama Lengkap</Label>
              <Input data-testid="kost-form-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1 bg-white text-stone-900" placeholder="Nama kamu" />
            </div>
            <div>
              <Label className="text-amber-100">Nomor HP / WhatsApp</Label>
              <Input data-testid="kost-form-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="mt-1 bg-white text-stone-900" placeholder="0812xxxxxxxx" />
            </div>
            <div>
              <Label className="text-amber-100">Cabang yang Dikunjungi</Label>
              <Select value={form.branch} onValueChange={(v) => setForm({ ...form, branch: v })}>
                <SelectTrigger data-testid="kost-form-branch" className="mt-1 bg-white text-stone-900"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="kost-01">FAS KOST 01 — Blok A No. 12</SelectItem>
                  <SelectItem value="kost-02">FAS KOST 02 — Blok B No. 9</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-amber-100">Tipe Kamar yang Dilihat</Label>
              <Select value={form.room_type} onValueChange={(v) => setForm({ ...form, room_type: v })}>
                <SelectTrigger data-testid="kost-form-room" className="mt-1 bg-white text-stone-900"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="kipas">Kamar Kipas + Toilet Luar — Rp 650rb/bln</SelectItem>
                  <SelectItem value="ac">Kamar AC + Toilet Dalam — Rp 1jt/bln</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-amber-100">Rencana Tanggal Kunjungan</Label>
              <Input data-testid="kost-form-date" type="date" value={form.visit_date} onChange={(e) => setForm({ ...form, visit_date: e.target.value })} className="mt-1 bg-white text-stone-900" />
            </div>
            <div className="sm:col-span-2">
              <Label className="text-amber-100">Catatan (opsional)</Label>
              <Textarea data-testid="kost-form-notes" value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} className="mt-1 bg-white text-stone-900" rows={2} placeholder="Mis. bisa datang sore setelah jam kerja" />
            </div>
          </div>
          <Button
            data-testid="kost-form-submit-btn"
            onClick={submit}
            disabled={loading}
            className="mt-6 rounded-full bg-amber-400 text-stone-900 hover:bg-amber-300 font-bold px-8 py-6 text-base"
          >
            {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Mengirim...</> : "Kirim Booking Kunjungan"}
          </Button>
        </div>
      </section>

      <footer className="relative border-t border-[#E5DECF] py-6 text-center text-xs text-stone-500 font-mono uppercase tracking-widest">
        <a data-testid="footer-wa-link" onClick={() => trackWaClick("kost")} href="https://wa.me/6281377114000?text=Halo%20Admin%20FAS%20Group%2C%20saya%20mau%20tanya%20FAS%20KOST..." target="_blank" rel="noopener noreferrer" className="mb-3 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-700 text-white text-sm font-bold normal-case tracking-normal hover:bg-emerald-800 transition">
          <MessageCircle className="w-4 h-4" /> Admin FAS Group Corp.
        </a>
        <div>FAS KOST by FAS Group · Hunian nyaman harga tetangga</div>
        <img src="https://customer-assets-7cd3h4nn.emergentagent.net/job_fasmart-online/artifacts/kpyu0nvc_ChatGPT%20Image%2026%20Agu%202026%2C%2012.19.43.png" alt="FAS Group Corp" data-testid="footer-fasgroup-logo" className="mx-auto mt-4 h-14 w-auto object-contain rounded-xl bg-white p-1.5 border border-[#E5DECF] md:absolute md:right-6 md:bottom-4 md:m-0 md:h-16" />
      </footer>

      <Lightbox
        images={lightbox.images}
        index={lightbox.index}
        onClose={() => setLightbox((l) => ({ ...l, index: null }))}
        onNavigate={(i) => setLightbox((l) => ({ ...l, index: i }))}
      />
    </div>
  );
}
